import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=2ce3a552&scoped=true"
import script from "./addressDetail.vue?vue&type=script&lang=js"
export * from "./addressDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3a552",
  null
  
)

export default component.exports